import {type ScheduleOtimizationRange} from '@domain/schedule'
import {ChartDateIndicator} from '@hconnect/ganttchart/src/modules'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {useTheme} from '@mui/material'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE} from '../../../consts'
import {usePlanningChartStartEnd} from '../../providers'

type ChartOptimizedPlanStartEndIndicatorProps = {
  hoursDisplayed: number
  cellWidth: number
  optimizationRange: ScheduleOtimizationRange
}

export const ChartOptimizedPlanStartEndIndicator: React.FC<
  ChartOptimizedPlanStartEndIndicatorProps
> = ({hoursDisplayed, cellWidth, optimizationRange}) => {
  const theme = useTheme()
  const timezoneId = useUpmPlantTimezone()
  const {t} = useTranslation(PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE)

  const from = moment.utc(optimizationRange.from).tz(timezoneId)
  const to = moment.utc(optimizationRange.to).tz(timezoneId)

  const {startOfChart, endOfChart} = usePlanningChartStartEnd()

  return (
    <>
      <ChartDateIndicator
        label={t('optimizer.optimizedPlanStarts', {
          time: from.format('HH:mm')
        })}
        hoursDisplayed={hoursDisplayed}
        cellWidth={cellWidth}
        time={from}
        backgroundColor={theme.palette.primary.main}
        color={theme.palette.background.paper}
        startOfChart={startOfChart}
        endOfChart={endOfChart}
      />
      <ChartDateIndicator
        label={t('optimizer.optimizedPlanEnds', {
          time: to.format('HH:mm')
        })}
        hoursDisplayed={hoursDisplayed}
        cellWidth={cellWidth}
        time={to}
        backgroundColor={theme.palette.primary.main}
        color={theme.palette.background.paper}
        startOfChart={startOfChart}
        endOfChart={endOfChart}
      />
    </>
  )
}
